<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #drawer class="sidenav" fixedInViewport
      [mode]="'side'"
      [opened]="true">
    <mat-toolbar>
      <img class="logo" src="assets/images/logo_savifirst.png" alt="Logo" class="logo">
      <span>SAVIFIRST</span>
    </mat-toolbar>
    <mat-nav-list>
      <a mat-list-item *ngFor="let item of menuItems" 
         [routerLink]="item.path" 
         routerLinkActive="active"
         [routerLinkActiveOptions]="{exact: item.path === '/invoices'}"
         class="menu-item">
        <mat-icon>{{item.icon}}</mat-icon>
        <span class="menu-label">{{item.label | translate}}</span>
      </a>
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content>
    <mat-toolbar>
      <button mat-icon-button class="menu-button" (click)="drawer.toggle()">
        <mat-icon>menu</mat-icon>
      </button>
      <span class="app-title">{{getCurrentPageTitle() | translate}}</span>
      <span class="spacer"></span>
      <div class="header-actions">
        <div class="profile-section">
          <button mat-button [matMenuTriggerFor]="userMenu" class="profile-button">
            <div class="profile-info">
              <div class="profile-image">
                <mat-icon>account_circle</mat-icon>
              </div>
              <div class="profile-text">
                <span class="profile-name">{{ username || 'Profile name' }}</span>
                <!-- <span class="profile-role">{{ userRole }}</span> -->
              </div>
            </div>
            <mat-icon>expand_more</mat-icon>
          </button>
        </div>
      </div>
    </mat-toolbar>
    <div class="content">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>

<mat-menu #userMenu="matMenu" class="profile-menu">
  <button mat-menu-item (click)="logout()" class="logout-item">
    <mat-icon>logout</mat-icon>
    <span>{{ 'MENU.LOGOUT' | translate }}</span>
  </button>
</mat-menu> 